/* eslint-disable max-len */
import PropTypes from 'prop-types'
import { positionPropType } from '../common/position-prop-type'

/**
 * @typedef {Object} ActiveCouplings
 * @property {string}   [assetObjectId]     - The ID of the asset.
 * @property {string}   [couplingId]        - The ID of the coupling.
 * @property {Position} [couplingPosition]  - The position information about the active coupling event, including longitude and latitude.
 * @property {ISO8601}  [couplingTime]      - The time when the coupling happened (ISO8601).
 * @property {string}   [vehicleObjectId]   - The ID of the vehicle.
 */
const activeCouplingsPropType = PropTypes.shape({
    assetObjectId: PropTypes.string.isRequired,
    couplingId: PropTypes.string.isRequired,
    couplingPosition: positionPropType.isRequired,
    couplingTime: PropTypes.string.isRequired,
    vehicleObjectId: PropTypes.string.isRequired
})

export { activeCouplingsPropType }
